import React, { useMemo } from 'react'
import moment from 'moment'
import { makeStyles } from '@mui/styles'

import lang from '@/lang'
import config from '@/config'
import MultipleListing from '@/modules/base/components/listing/multiple'
import ThemeInterface from '@/theme-interface'
import { Signer } from '@/modules/signature/types'
import SignatureSigningInfoSignerItem from './signature-signing-info-signer-item'

const useStyles = makeStyles((theme: ThemeInterface) => ({
  root: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
  },
  signers: {
    display: 'flex',
    flexDirection: 'column',
  },
  signersLabel: {
    fontSize: theme.fontSizes.smedium,
    fontWeight: theme.fontWeights.medium,
    marginBottom: 11,
  },
  infos: {
    display: 'flex',
  },
  infoItem: {
    display: 'flex',
    flexDirection: 'column',
    marginRight: 40,
    '&:last-of-type': {
      marginRight: 0,
    },
  },
  infoItemLabel: {
    color: theme.labelLight,
    textTransform: 'uppercase',
    textAlign: 'right',
    marginBottom: 11,
  },
}), { name: 'SignatureSigningInfo' })

type SignatureSigningInfoProp = {
  signers: Signer[],
  dueDate: string,
  onSend: (email: string) => void,
}

const SignatureSigningInfo = (props: SignatureSigningInfoProp) => {
  const classes = useStyles()
  const { signers, dueDate, onSend } = props

  const activeMultipleListingItem = useMemo(() => {
    const { name, email } = signers[0]
    return (
      <SignatureSigningInfoSignerItem
        active
        name={name}
        email={email}
        onSend={onSend} />
    )
  }, [signers])
  const multipleListingContent = useMemo(() => {
    const [, ...otherSigners] = signers
    return otherSigners.map((signer) => (
      <SignatureSigningInfoSignerItem
        name={signer.name}
        email={signer.email}
        onSend={onSend} />
    ))
  }, [signers])

  return (
    <div className={classes.root}>
      <div className={classes.signers}>
        <span className={classes.signersLabel}>{lang.signature.signing.info.signers.label}</span>
        <MultipleListing
          tooltipLabel={lang.signature.signing.info.signers.tooltipLabel}
          customActiveElement={activeMultipleListingItem}
          customContent={multipleListingContent}
          elements={signers} />
      </div>
      <div className={classes.infos}>
        <div className={classes.infoItem}>
          <span className={classes.infoItemLabel}>{lang.signature.signing.info.type.label}</span>
          <span>{lang.signature.signing.info.type.value}</span>
        </div>
        <div className={classes.infoItem}>
          <span className={classes.infoItemLabel}>{lang.signature.signing.info.dueDate.label}</span>
          <span>{moment(dueDate).format(config.dateFormat.client)}</span>
        </div>
      </div>
    </div>
  )
}

export default SignatureSigningInfo
